module.exports = __webpack_public_path__ + "img/banner_icon_5.42d08921.png";